
















import Vue from "vue";

// Import Components
import Button from "@miele/component-library-vue/src/components/elements/button/Button.vue";
import Block from "@miele/component-library-vue/src/components/content/layouts/Block.vue";

export default Vue.extend({
  name: "LoadMoreButtonContainer",
  components: {
    Button,
    Block,
  },
  computed: {
    translations() {
      return this.$store.state.translations;
    },
  },
  methods: {
    async loadMore(event: MouseEvent) {
      const body = document.body;
      body.classList.add("loading");
      await this.$store.dispatch("loadMore");
      event.preventDefault();
    },
  },
});
